class Overlay {

    constructor(overlayClass) {
        this.overlay = null;
        this.hideOverlay = null;

        // create overlay element
        this.overlay = document.createElement('div');
        this.overlay.classList.add(overlayClass);

        // append to body
        document.body.appendChild(this.overlay);
    }

    show() {
        this.overlay.style.display = 'block';
    }

    hide() {
        if (this.overlay) {
            this.overlay.style.display = 'none';
        }
    }
}

export default Overlay;